import React from "react";
import { Link } from "react-router-dom";

import * as CHQ from "chq";
import { t } from "app/utils/trans";

export const getEventPath = (event: CHQ.Event) => `/events/${event.id}`;

type EventLinkProps = Omit<React.ComponentProps<typeof Link>, "to"> & {
  children?: React.ReactNode;
  event: CHQ.Event;
  tabIndex?: number;
};

const EventLink: React.FC<EventLinkProps> = ({ children, event, tabIndex, ...props }) => (
  <Link {...props} to={getEventPath(event)} tabIndex={tabIndex || 0} aria-label={t(`${event.name} link`)}>
    {children || event.name}
  </Link>
);

export default EventLink;
